var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headertop',{on:{"changeSort":_vm.changeSort}}),_c('fenleilist',{ref:"fenleilist"}),_c('bottombox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }